export default __webpack_public_path__ + "static/media/phone-list-cropped.24678457.png";